<template>
    <section id="download">
        <div class="container">
            <div class="col catalog">
              <a :href="link('catalog')">
                    <div class="catalog-icon icon-wrap"><div class="icon"></div></div>
                    <div class='download-label'>
                        <h2 v-translate="'dwn_catalog'">Pobierz katalog</h2>
                    </div>
                </a>
                <div class="download-button">
                    <a :href="link('catalog')" class="btn mint"  v-translate="'dwn_catalog_l'"></a>
                </div>
            </div>

            <div class="col wallpapers">
              <a :href="link('wallpapers')">
                    <div class="laptop-icon icon-wrap"><div class="icon"></div></div>
                    <div class='download-label'>
                        <h2  v-translate="'dwn_wallpapers'"></h2>
                    </div>
                </a>
                <div class="download-button">
                    <a :href="link('wallpapers')" class="btn mint"  v-translate="'dwn_wallpapers_l'"></a>
                </div>
            </div>

            <div class="col dealers">
                <a :href="link('dealers')">
                    <div class="marker-icon icon-wrap"><div class="icon"></div></div>
                    <div class='download-label'>
                        <h2  v-translate="'dwn_dealers'"></h2>
                    </div>
                </a>
                <div class="download-button">
                    <a :href="link('dealers')" class="btn mint"  v-translate="'dwn_dealers_l'">
                        Znajdź dealera
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default {
  name: 'Download',
  methods: {
    link(to) {
      return window.env.baseUrl + window.translations['rt_' + to];
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Blocks/Download.vue